/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { ReactNode } from "react";
import radioPadStyle from "./radioPadStyle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Button, FormControl, Typography } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";

type PadProps = {
  type: "checkbox" | "radio";
  active: boolean;
  error: boolean;
  optionHintText?: string | ReactNode | null;
  labelIcon: ReactNode;
  labelIconActive?: ReactNode;
  labelText: string;
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
  fullWidth?: boolean;
};
export default function Pad({ optionHintText = "", labelIcon, labelIconActive, labelText, name, onChange, value, active, error, type, fullWidth = false  }: PadProps) {
  return (
    <FormControl sx={mergeSx(radioPadStyle.wrapper, !fullWidth && radioPadStyle.wrapperMaxWidth)}>
      <Button
        sx={{
          all: "unset",
          display: "block",
          width: "100%",
          borderRadius: "0.5rem",
        }}
        onClick={() =>
          onChange({
            target: {
              name: name + (type === "checkbox" ? "." + value : ""),
              value: value,
            },
          } as React.ChangeEvent<HTMLInputElement>)
        }
      >
        <Paper elevation={0} sx={mergeSx(radioPadStyle.paper, active && radioPadStyle.activePad, error && radioPadStyle.errorPad)}>
          <Grid container>
            <Grid sx={mergeSx(radioPadStyle.labelIcon, active && radioPadStyle.activeColor)} size={12}>
              {active && labelIconActive ? labelIconActive : labelIcon}
            </Grid>
            <Grid sx={radioPadStyle.labelText} size={12}>
              <Typography variant={"body2"} component={"div"} sx={{ color: "inherit" }}>
                <strong>{labelText}</strong>
              </Typography>
            </Grid>
            {optionHintText && (
              <Grid size={12}>
                <Typography variant={"caption"} component={"div"}>
                  {optionHintText}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Button>
    </FormControl>
  );
}
